module.exports = __webpack_public_path__ + "img/check.4aecd2ea.png";